import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Portfolio from '@/components/Portfolio'
import Contact from '@/components/Contact'
import About from '@/components/About'
import Dashboard from '@/components/Dashboard'
import ViewMessage from '@/components/ViewMessage'
import Blog from '@/components/Blog'
import firebase from 'firebase'


Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      component: Portfolio,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/view-message',
      name: 'view-message',
      component: ViewMessage,
      meta: {
        requiresGuest: true
      }
    },
    
  ]
})


//Nav Gaurd

router.beforeEach((to, from, next) => {
  //check for requiredAuth
  if(to.matched.some(record => record.meta.requiresAuth)){
    //check if Not logged in
    if(!firebase.auth().currentUser){
      //GOTO Login Page
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else{
      //Proceed
      next()
    }
  } else if(to.matched.some(record => record.meta.requiresGuest)){
     //check if  logged in
     if(firebase.auth().currentUser){
      //GOTO Dashboard Page
      next({
        path: '/dashboard',
        query: {
          redirect: to.fullPath
        }
      })
    } else{
      //Proceed
      next()
    }
  } else{
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js